<template>
  <nav class="navbar-default navbar-static-side" role="navigation" style="
    height: 100%;
    background: #2f4050;
">
    <div class="sidebar-collapse">
      <ul class="nav" id="side-menu" style="padding-left: 0">
        <li class="nav-header">
          <div class="dropdown profile-element">
            <span>
              <img :src="require('@/assets/image/main-logo.png')" width="90%" alt="Logo RoboMarket" />
            </span>
            <a data-toggle="dropdown" class="dropdown-toggle" href="#">
              <span class="clear">
                <span class="block m-t-xs">
                  <strong class="font-bold">
                    <span v-if="authUser">{{ authUser.displayName ? authUser.displayName : authUser.email }}</span>
                  </strong>
                </span>
                <span class="text-muted text-xs block" v-if="userType && userData">
                  {{ userType[userData.type] }}
                  <b class="caret"></b>
                </span>
              </span>
            </a>
            <ul class="dropdown-menu animated fadeInRight m-t-xs">
              <li>
                <router-link to="/dashboard/profile">Minha conta</router-link>
              </li>
              <li v-if="userData && userData.type === 'supermarket'">
                <router-link to="/dashboard/configuracoes-avancadas">Configurações avançadas</router-link>
              </li>
              <li class="divider"></li>
              <li>
                <a @click="doLogout()">Logout</a>
              </li>
            </ul>
          </div>

          <div class="logo-element">
            <img alt="image" :src="require('@/assets/admin/img/zapbot_head.png')" width="50%" />
          </div>
        </li>
        <li v-if="userData && userData.type !== 'picker'">
          <router-link to="/dashboard">
            <i class="fa fa-th-large"></i>
            <span class="nav-label">Home</span>
          </router-link>
        </li>


        <li v-for="(menuItem, index) in sideMenuItems" :key="index">
          <a href="javascript:void(0)" v-if="authUser && ( authUser.claims && menuItem.levels.includes(authUser.claims.role) ) && (menuItem.children && menuItem.children.length)" aria-expanded="false">
            <i v-if="menuItem.icon" :class="menuItem.icon"></i>
            <i v-else class="fa fa-users"></i>
            <span class="nav-label">{{ menuItem.title }}</span>
            <span class="fa arrow"></span>
          </a>

          <ul class="nav nav-second-level" v-if="authUser && ( authUser.claims && menuItem.levels.includes(authUser.claims.role) )  && menuItem.children && menuItem.children.length">
            <li v-for="(subItem, j) in menuItem.children" :key="j">
              <router-link :to="subItem.to">{{ subItem.title }}</router-link>
            </li>
          </ul>


          <!-- Quando não tiver subitem -->
          <router-link :to="menuItem.to" v-if="(!menuItem.children || menuItem.children.length === 0) && authUser && (authUser.claims && menuItem.levels.includes(authUser.claims.role))">
            <i :class="menuItem.icon"></i>
            <span class="nav-label">{{ menuItem.title }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
/* eslint-disable */
import "metismenu";
import "jquery-slimscroll";
import { mapGetters, mapState, mapMutations } from "vuex";
import * as firebase from "firebase/app";
import 'firebase/auth';
export default {
  computed: {
    ...mapGetters(["userType", "userData", 'sideMenuItems']),
    ...mapState(['authUser'])
  },
  methods: {
    ...mapMutations(['setAuthUser', 'setUserData']),
    doLogout() {
      firebase.auth().signOut();
      this.setAuthUser(null);
      this.setUserData(null);
      this.$router.replace("/signin");
    },
  },
  mounted() {
    $("#side-menu").metisMenu({
      toggle: false,
    });
  },
};
</script>


<style lang="scss">
  #side-menu {
    li {
      a[aria-expanded=false] ~ ul {
        visibility: hidden;
        height: 0;
      }  
    }
  }
</style>
